import { Component, OnInit, Input } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { CommonActionKey, MessageService, SimpleDialogService } from 'common';
import { Subscription } from 'rxjs';
import { UserPermissionService } from '../../../user/user-permission/user-permission.service';
import { readWrite } from '../../../user/user-permission/user-permission.data';
import { CustomerData, CustomerStatus } from '../../customer.model';
import { CustomerService } from '../../customer.service';

@UntilDestroy()
@Component({
    selector: 'ifb-customer-info-widget',
    templateUrl: './customer-info-widget.component.html',
    styleUrls: ['./customer-info-widget.component.scss'],
    standalone: false
})
export class CustomerInfoWidgetComponent implements OnInit {
  @Input()
  data: CustomerData;

  @Input()
  edit: boolean;

  private saveSub: Subscription;
  canSendEmail: boolean;
  readonly CustomerStatus = CustomerStatus;

  constructor(
    private readonly customerService: CustomerService,
    private readonly userPermissionService: UserPermissionService,
    private readonly simpleDialogService: SimpleDialogService,
    private readonly messageService: MessageService
  ) {}

  ngOnInit(): void {
    this.userPermissionService.granted([readWrite('servicing-customers-registration-data')])
      .pipe(untilDestroyed(this))
      .subscribe(res => this.canSendEmail = res);
  }

  resendInvitation(): void {
    if (this.saveSub) {
      return;
    }

    const message = `Send an email to ${this.data.firstName} ${this.data.lastName} at ${this.data.email} with instructions to activate their account?`;
    this.simpleDialogService.openSimpleConfirmDialog(message, "Confirm")
    .subscribe((result: CommonActionKey) => {
      if (result === CommonActionKey.Confirm) {
        this.saveSub = this.customerService.resendInvitation(this.data.id)
          .subscribe(this.saveSuccessHandler.bind(this), this.saveErrorHandler.bind(this));
      }
    });
  }

  private saveSubClear(): void {
    if (this.saveSub)
      this.saveSub = null;
  }

  private saveSuccessHandler(): void {
    this.saveSubClear();
    this.messageService.success("An email has been sent successfully.", "OK");
  }

  private saveErrorHandler(response: any): void {
    this.saveSubClear();
    const message = response.error ? response.error.Message : 'Error ocurred while trying to sent email';
    this.messageService.error(message, "Error");
  }
}
